export class  UserQuota {
    quotaReached: boolean;
    isSessionAlive: boolean;
    sessionAlive: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/userquota.model.ts